import { render, staticRenderFns } from "./BattleUnregisterCrew.vue?vue&type=template&id=485989a5&scoped=true"
import script from "./BattleUnregisterCrew.vue?vue&type=script&lang=js"
export * from "./BattleUnregisterCrew.vue?vue&type=script&lang=js"
import style0 from "./BattleUnregisterCrew.vue?vue&type=style&index=0&id=485989a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "485989a5",
  null
  
)

export default component.exports